import { AvailableToPurchaseFlag, ProductVariantViewModel } from '@/types/api'

import { WEIGHT_UNITS } from '../constants'

export const getVariantSummary = (variants: ProductVariantViewModel[]) => {
    const uniqueColorVariants: ProductVariantViewModel[] = []
    const uniqueWeightVariants: ProductVariantViewModel[] = []
    const allLeadTimes: number[] = []

    let hasAtLeastOnePharmacy = false
    let isFullyShipBySeller = true
    let isFullyWithLeadTime = true
    let isFullyWithoutShipBySeller = true
    let hasAtleastOneWeightUnit = false

    variants?.map((variant) => {
        const color = variant.color?.id
        const weightValue = variant.weight?.value
        const weightUnit = variant.weight?.unit

        if (!color && !weightValue) return

        const isPharmacy = variant.flags?.includes(AvailableToPurchaseFlag.Pharmacy)
        if (isPharmacy) {
            hasAtLeastOnePharmacy = true
        }

        if (variant.shipBySeller) {
            isFullyWithoutShipBySeller = false
        } else {
            isFullyShipBySeller = false
        }

        if (!variant.leadTime) {
            isFullyWithLeadTime = false
        }

        if (variant.leadTime) {
            allLeadTimes.push(variant.leadTime)
        }

        if (weightUnit && WEIGHT_UNITS.includes(weightUnit.toLowerCase())) {
            hasAtleastOneWeightUnit = true
        }

        if (weightValue) {
            const indexInUniqueWeightVariants = uniqueWeightVariants.findIndex(
                (v) => v.weight?.value === weightValue && v.weight?.unit === weightUnit
            )
            if (indexInUniqueWeightVariants !== -1) {
                if (!uniqueWeightVariants[indexInUniqueWeightVariants].isSalable && variant.isSalable) {
                    uniqueWeightVariants[indexInUniqueWeightVariants].isSalable = true
                }
            } else {
                uniqueWeightVariants.push({ ...variant })
            }
        }

        if (color) {
            const indexInUniqueColorVariants = uniqueColorVariants.findIndex((v) => v.color?.id === color)

            if (indexInUniqueColorVariants !== -1) {
                if (!uniqueColorVariants[indexInUniqueColorVariants].isSalable && variant.isSalable) {
                    uniqueColorVariants[indexInUniqueColorVariants].isSalable = true
                }
            } else {
                uniqueColorVariants.push({ ...variant })
            }
        }
    })

    const minimumLeadTime = Math.min(...allLeadTimes)

    const sortedWeightVariants = uniqueWeightVariants.sort((a, b) => {
        const aWeight = a.weight?.value ?? 0
        const bWeight = b.weight?.value ?? 0
        return aWeight - bWeight
    })

    return {
        uniqueColorVariants,
        uniqueWeightVariants: sortedWeightVariants,
        hasAtLeastOnePharmacy,
        isFullyShipBySeller,
        isFullyWithLeadTime,
        isFullyWithoutShipBySeller,
        minimumLeadTime,
        hasAtleastOneWeightUnit,
    }
}
